export default "__VITE_ASSET__BgzBibd8__"